import { render } from "./manage-notification.vue?vue&type=template&id=3079b03c&scoped=true&ts=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts"
export * from "./manage-notification.vue?vue&type=script&lang=ts"

import "./manage-notification.vue?vue&type=style&index=0&id=3079b03c&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3079b03c"]])

export default __exports__